import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseIconButton, LinkIconButton } from './BaseIconButton';

const destructivePrimaryIconButtonStyle = {
    color: colorSystem.neutral.white,
    background: colorSystem.red[7],
    borderRadius: '4px',
    border: `1px solid ${colorSystem.red[7]}`,
    '&:hover': {
        background: colorSystem.red[8],
        border: `1px solid ${colorSystem.red[8]}`,
    },
    '&:active': {
        background: colorSystem.red[9],
        border: `1px solid ${colorSystem.red[9]}`,
    },
    '&:disabled': {
        color: colorSystem.neutral.white,
        background: colorSystem.neutral[5],
        border: `1px solid ${colorSystem.neutral[5]}`,
    },
};

const DestructivePrimaryIconButtonHost = styled(BaseIconButton)(destructivePrimaryIconButtonStyle);
const DestructivePrimaryIconButtonLinkHost = styled(LinkIconButton)(destructivePrimaryIconButtonStyle);

export const DestructivePrimaryIconButton = linkable(DestructivePrimaryIconButtonHost, {
    linkHost: DestructivePrimaryIconButtonLinkHost,
});
